export default __webpack_public_path__ + "static/media/arrow_down_icon.bcf2b20b.svg";